// SPDX-License-Identifier: AGPL-3.0-or-later

import {msg} from '@lingui/core/macro';

export const COLORS_DESCRIPTOR = msg({
	message: 'Colors',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const FONTS_DESCRIPTOR = msg({
	message: 'Fonts',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const COLOR_DESCRIPTOR = msg({
	message: 'Color',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const MESSAGES_3_DESCRIPTOR = msg({
	message: 'Messages',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const SIDEBAR_2_DESCRIPTOR = msg({
	message: 'Sidebar',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const CHANNEL_LIST_DESCRIPTOR = msg({
	message: 'Channel list',
	comment: 'Settings section label. Also used as a search synonym in the settings search bar.',
});
export const NAVIGATION_DESCRIPTOR = msg({
	message: 'Navigation',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const TYPING_DESCRIPTOR = msg({
	message: 'Typing',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const INDICATOR_DESCRIPTOR = msg({
	message: 'Indicator',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const KEYBOARD_2_DESCRIPTOR = msg({
	message: 'Keyboard',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const KEYBOARD_HINTS_DESCRIPTOR = msg({
	message: 'Keyboard hints',
	comment: 'Toggle label and settings search entry for controlling tooltip keyboard shortcut hints.',
});
export const SHOW_NEKO_DESCRIPTOR = msg({
	message: 'Show Neko',
	comment: 'Toggle label and settings search entry for showing the Neko sprite that chases the cursor.',
});
export const KEEP_NEKO_STILL_DESCRIPTOR = msg({
	message: 'Keep Neko still',
	comment: 'Toggle label and settings search entry for stopping the Neko sprite from chasing the cursor.',
});
export const ENABLE_FAVORITES_DESCRIPTOR = msg({
	message: 'Enable favorites',
	comment: 'Toggle label and settings search entry for controlling whether favorites are visible throughout the app.',
});
export const NEKO_DESCRIPTOR = msg({
	message: 'Neko',
	comment: 'Settings search synonym. Proper name of the optional cat sprite that chases the cursor.',
});
export const CHAT_INPUT_DESCRIPTOR = msg({
	message: 'chat input',
	comment: 'Settings search synonym. Refers to the message composer area.',
});
export const MUTED_CHANNELS_DESCRIPTOR = msg({
	message: 'Muted channels',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const MUTED_DESCRIPTOR = msg({
	message: 'Muted',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const UNREAD_DESCRIPTOR = msg({
	message: 'Unread',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const VOICE_DESCRIPTOR = msg({
	message: 'Voice',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const DIRECT_MESSAGE_DESCRIPTOR = msg({
	message: 'Direct message',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const FRIENDS_DESCRIPTOR = msg({
	message: 'Friends',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const ACCESSIBILITY_DESCRIPTOR = msg({
	message: 'Accessibility',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const DIM_STRIKETHROUGH_TEXT_DESCRIPTOR = msg({
	message: 'Dim strikethrough text',
	comment: 'Toggle label and settings search entry for slightly muting text formatted with Markdown strikethrough.',
});
export const SHOW_STRIKETHROUGH_MARKDOWN_TEXT_IN_A_SLIGHTLY_MUTED_COLOR_DESCRIPTOR = msg({
	message: 'Show strikethrough markdown text in a slightly muted color.',
	comment:
		'Description for a visual accessibility setting that mutes the color of text formatted with Markdown strikethrough.',
});
export const STRIKETHROUGH_DESCRIPTOR = msg({
	message: 'Strikethrough',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const STRIKE_THROUGH_DESCRIPTOR = msg({
	message: 'Strike through',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const DELETED_TEXT_DESCRIPTOR = msg({
	message: 'Deleted text',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const GRAY_TEXT_DESCRIPTOR = msg({
	message: 'Gray text',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const MARKDOWN_DESCRIPTOR = msg({
	message: 'Markdown',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const READ_MESSAGES_DESCRIPTOR = msg({
	message: 'Read messages',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const READ_ALOUD_DESCRIPTOR = msg({
	message: 'Read aloud',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const TTS_DESCRIPTOR = msg({
	message: 'TTS',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const TEXT_TO_SPEECH_3_DESCRIPTOR = msg({
	message: 'Text to speech',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const SPEECH_DESCRIPTOR = msg({
	message: 'Speech',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const NARRATION_DESCRIPTOR = msg({
	message: 'Narration',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const CALL_DESCRIPTOR = msg({
	message: 'Call',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const CONTEXT_MENU_DESCRIPTOR = msg({
	message: 'Context menu',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const GIF_DESCRIPTOR = msg({
	message: 'GIF',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const EMOJI_DESCRIPTOR = msg({
	message: 'Emoji',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const MENTIONS_DESCRIPTOR = msg({
	message: 'Mentions',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const AUDIO_2_DESCRIPTOR = msg({
	message: 'Audio',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const VOLUME_DESCRIPTOR = msg({
	message: 'Volume',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const PLUTONIUM_DESCRIPTOR = msg({
	message: 'Plutonium',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const DM_DESCRIPTOR = msg({
	message: 'DM',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const PING_DESCRIPTOR = msg({
	message: 'Ping',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const DELETE_DESCRIPTOR = msg({
	message: 'Delete',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const REMOVE_DESCRIPTOR = msg({
	message: 'Remove',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const POPUP_DESCRIPTOR = msg({
	message: 'Popup',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
